import { render, staticRenderFns } from "./ProformaList.vue?vue&type=template&id=7d0f1372&"
import script from "./ProformaList.vue?vue&type=script&lang=js&"
export * from "./ProformaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports